import React, { FC, useCallback } from 'react'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { GreyButton } from 'components/Button'
import { useDispatch } from 'react-redux'
import { closeModal } from 'reducks/modal/operations'
import { FlexColumn } from 'components/Flex'

const NotificationModal: FC = () => {
  const dispatch = useDispatch()
  const closeModalCallback = useCallback(() => dispatch(closeModal()), [dispatch])

  return (
    <FlexColumn alignItems={'center'} data-cy={'notification-modal'}>
      <img src={'/icon/done/notification.svg'} alt={'通知しました'} />
      <Spacer size={12} />
      <h2 className={text.font_xxxlarge}>通知しました</h2>
      <Spacer size={12} />
      <p className={text.align_center}>
        取り置き通知をオンにしているお客さまに
        <br />
        取り置きできることを通知しました。
      </p>
      <Spacer size={8} />
      <p className={`${text.align_center} ${text.color_orange_main}`}>
        次回の通知は30分以降に
        <br />
        送ることが可能になります。
      </p>
      <Spacer size={20} />
      <GreyButton
        dataCy={'notification-modal'}
        label={'閉じる'}
        onClick={closeModalCallback}
        size={'medium'}
        type={'outlined'}
      />
    </FlexColumn>
  )
}

export default NotificationModal
